import * as api from "./client";

export type NetworkJurisdictionRanking = {
  id: string;
  networkId: string;
  networkIdNum: number | null;
  networkName: string;
  countryId: number;
  countrySlug: string;
  countryName: string;
  firmRef: number | null;
  firmNetworkMemberId: string;
  firmName: string;
  edition: string;
  score: string;
};

export type NetworkJurisdictionRankingsListResponse = {
  data: NetworkJurisdictionRanking[];
  meta: {
    total: number;
    limit: number;
    offset: number;
    filters?: {
      network_id?: string;
      country_slug?: string;
      edition?: string;
      search?: string;
    };
  };
};

export type NetworkJurisdictionRankingsQuery = {
  search?: string;
  network_id?: string;
  country_slug?: string;
  edition?: string;
  limit?: number;
  offset?: number;
};

function buildQueryString(params: NetworkJurisdictionRankingsQuery): string {
  const searchParams = new URLSearchParams();
  if (params.search) searchParams.set("search", params.search);
  if (params.network_id) searchParams.set("network_id", params.network_id);
  if (params.country_slug) searchParams.set("country_slug", params.country_slug);
  if (params.edition) searchParams.set("edition", params.edition);
  if (params.limit !== undefined) searchParams.set("limit", params.limit.toString());
  if (params.offset !== undefined) searchParams.set("offset", params.offset.toString());
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export const networkJurisdictionRankings = {
  getAll: async (
    params: NetworkJurisdictionRankingsQuery = {},
  ): Promise<NetworkJurisdictionRankingsListResponse> => {
    const queryString = buildQueryString(params);
    return api.get<NetworkJurisdictionRankingsListResponse>(
      `/v1/data-marts/network-jurisdiction-rankings${queryString}`,
    );
  },
};
